import classNames from 'classnames';
import { Drawer, DrawerProps } from 'antd';

const MobileDrawer: React.FC<DrawerProps> = (props) => {
  return (
    <Drawer
      {...props}
      rootClassName={classNames(props.rootClassName, 'trojan-mobile-drawer')}
      placement="bottom"
    />
  );
};

export default MobileDrawer;
